import PaymentTypes, { PaymentTitle } from "./paymentSubjects";
import ReceiveTypes, { ReceiveTitle } from "./reciveSubjects";
import { MANAGER_IMPREST_STATES, ManagerImprestStateText } from "./pettycash";

export const SORTS = {
  DATE: { label: "تاریخ", name: "date" },
  CREATED_AT: { label: "تاریخ و ساعت ثبت", name: "created_at" },
  DESCRIPTION: { label: "شرح", name: "description" },
  NAME: { label: "نام", name: "name" },
  CONTACT_NAME: { label: "نام", name: "contact_name" },
  AMOUNT: { label: "مبلغ", name: "amount" },
  IMPREST_NUMBER: { label: "شماره تنخواه", name: "imprest_number" },
  HASHTAG_COLOR: { label: "رنگ", name: "color" }
};

export const SORT_FIELDS = {
  DATE: "date",
  DESCRIPTION: "description",
  AMOUNT: "amount",
  REMAIN: "remain",
  RECEIVE_AMOUNT: "receive_amount",
  PAYMENT_AMOUNT: "payment_amount",
  NAME: "name",
  IMPREST_NUMBER: "imprest_number",
  IMAGE_COUNT: "image_count",
  HASHTAG_COLOR: "color",
  CONTACT_NAME: "contact_name"
};

export const SORT_TYPES = {
  ASCENDING: { key: "asc", label: "صعودی" },
  DESCENDING: { key: "desc", label: "نزولی" }
};

export const FILE_TYPE = "file_type";
export const ACCOUNT_TYPE = "account_type";
export const TYPE = "type";
export const SUB_TYPE = "sub_type";
export const DATE = "date";
export const DATE_TYPE = "date_type";
export const START_DATE = "start_date";
export const END_DATE = "end_date";
export const APPENDIX = "has_appendix";
export const ADD_APPENDIX = "add_appendix";
export const IMPREST_IDS = "imprest_ids";
export const IMPREST_NUMBER = "imprest_number";
export const RECEIVE_SUBJECTS = "receive_subject";
export const PAYMENT_SUBJECTS = "payment_subject";
export const SORT = "sort";
export const SORT_FIELD = "sort_field";
export const SORT_TYPE = "sort_type";
export const TEXT_SEARCH = "text_search";
export const CREATOR_USER_IDS = "creator_user_ids";
export const ROUTES = "routes";
export const PAGE_NUM = "p_num";
export const PAGE = "page";
export const PAGINATE = "paginate";
export const PER_PAGE = "per_page";
export const HASHTAG_IDS = "hashtag_ids";
export const CONTACT_IDS = "contact_ids";
export const HASHTAG_IDS_AND_fLAG = "hashtag_ids_and_flag";
export const ID = "id";
export const COPY_FROM = "copy_from";
export const MONTH = "month";
export const YEAR = "year";
export const USE_DETAIL = "use_detail";
export const BUDGET_ID = "budget_id";
export const INCLUDE_COST = "include_cost";
export const INCLUDE_BUDGET = "include_budget";
export const IMPREST_ID = "imprest_id";
export const USER_IDS = "user_ids";
export const USER_NAMES = "user_names";
export const TEAM_IDS = "team_ids";
export const IMPREST_STATES = "states";
export const IMPREST_STATES_FOR_OTHER_REPORTS = "imprest_states";
export const IMPREST_BUDGET_ID = "imprest_budget_id";

export const PROJECT_USER_ID = "project_user_id";

export const PETTY_CASH_NUMBER = "pettycash";

export const IS_EDIT = "is_edit";

export const CUSTODIAN_PROJECT_USER_ID = "custodian_project_user_id";

export const DEFAULT_APPENDIX = { key: -1, label: "همه" };
export const APPENDIX_TYPES = [
  DEFAULT_APPENDIX,
  { key: 0, label: "بدون پیوست" },
  { key: 1, label: "با پیوست" }
];

export const DEFAULT_PAYMENT_SUBJECTS = { key: -1, label: "همه موارد" };
export const PAYMENT_SUBJECTS_TYPES = [
  {
    key: PaymentTypes.BUY_OR_PAY,
    label: PaymentTitle[PaymentTypes.BUY_OR_PAY]
  },
  {
    key: PaymentTypes.RETURN_REMAIN,
    label: PaymentTitle[PaymentTypes.RETURN_REMAIN]
  }
];

export const DEFAULT_RECEIVE_SUBJECTS = { key: -1, label: "همه موارد" };
export const RECEIVE_SUBJECTS_TYPES = [
  {
    key: ReceiveTypes.PETTY_CASH_CHARGE,
    label: ReceiveTitle[ReceiveTypes.PETTY_CASH_CHARGE]
  },
  {
    key: ReceiveTypes.RETURN_COST,
    label: ReceiveTitle[ReceiveTypes.RETURN_COST]
  }
];

export const DEFAULT_IMPREST_NUM_STATUS = { key: 0, value: "همه" };
export const WITHOUT_IMPREST_NUM_STATUS = { key: -1, value: "بدون تنخواه" };

export const DEFAULT_USER_LIST = { key: 0, value: "همه" };
export const DEFAULT_TEAM_LIST = { key: 0, value: "همه" };

// export const IMPREST_STATES_ARRAY = [
//     { key: MANAGER_IMPREST_STATES.WAIT_FOR_ME, label: ManagerImprestStateText[MANAGER_IMPREST_STATES.WAIT_FOR_ME] },
//     { key: MANAGER_IMPREST_STATES.WAIT_FOR_FINALIZED, label: ManagerImprestStateText[MANAGER_IMPREST_STATES.WAIT_FOR_FINALIZED] },
//     { key: MANAGER_IMPREST_STATES.CONFIRMED, label: ManagerImprestStateText[MANAGER_IMPREST_STATES.CONFIRMED] },
//     { key: MANAGER_IMPREST_STATES.FINALIZED, label: ManagerImprestStateText[MANAGER_IMPREST_STATES.FINALIZED] },
//     { key: MANAGER_IMPREST_STATES.WAIT_FOR_OTHERS, label: ManagerImprestStateText[MANAGER_IMPREST_STATES.WAIT_FOR_OTHERS] },
//     { key: MANAGER_IMPREST_STATES.NOT_SENT, label: ManagerImprestStateText[MANAGER_IMPREST_STATES.NOT_SENT] },
//     // { key: FILTER_STATES.WITHOUT_PETTY_CASH, label: "بدون تنخواه" }
// ];
// export const DEFAULT_IMPREST_FILTER_STATES = [
//     { key: MANAGER_IMPREST_STATES.WAIT_FOR_ME, label: ManagerImprestStateText[MANAGER_IMPREST_STATES.WAIT_FOR_ME] },
//     { key: MANAGER_IMPREST_STATES.WAIT_FOR_FINALIZED, label: ManagerImprestStateText[MANAGER_IMPREST_STATES.WAIT_FOR_FINALIZED] },
//     { key: MANAGER_IMPREST_STATES.CONFIRMED, label: ManagerImprestStateText[MANAGER_IMPREST_STATES.CONFIRMED] },
//     { key: MANAGER_IMPREST_STATES.FINALIZED, label: ManagerImprestStateText[MANAGER_IMPREST_STATES.FINALIZED]  }
// ];
//
export const ALL_IMPREST_STATES_ARRAY = [
  {
    key: MANAGER_IMPREST_STATES.WAIT_FOR_ME,
    value: ManagerImprestStateText[MANAGER_IMPREST_STATES.WAIT_FOR_ME]
  },
  {
    key: MANAGER_IMPREST_STATES.WAIT_FOR_FINALIZED,
    value: ManagerImprestStateText[MANAGER_IMPREST_STATES.WAIT_FOR_FINALIZED]
  },
  {
    key: MANAGER_IMPREST_STATES.CONFIRMED,
    value: ManagerImprestStateText[MANAGER_IMPREST_STATES.CONFIRMED]
  },
  {
    key: MANAGER_IMPREST_STATES.FINALIZED,
    value: ManagerImprestStateText[MANAGER_IMPREST_STATES.FINALIZED]
  },
  {
    key: MANAGER_IMPREST_STATES.WAIT_FOR_OTHERS,
    value: ManagerImprestStateText[MANAGER_IMPREST_STATES.WAIT_FOR_OTHERS]
  },
  {
    key: MANAGER_IMPREST_STATES.NOT_SENT,
    value: ManagerImprestStateText[MANAGER_IMPREST_STATES.NOT_SENT]
  },
  {
    key: MANAGER_IMPREST_STATES.WITHOUT_PETTY_CASH,
    value: ManagerImprestStateText[MANAGER_IMPREST_STATES.WITHOUT_PETTY_CASH]
  }
];

export const WITHOUT_IMPREST_STATES = { key: -2, label: "" };
export const ALL_IMPREST_STATES = { key: -1, label: "همه موارد" };

export const DEFAULT_IMPREST_FILTER_STATES = [
  {
    key: MANAGER_IMPREST_STATES.WAIT_FOR_ME,
    value: ManagerImprestStateText[MANAGER_IMPREST_STATES.WAIT_FOR_ME]
  },
  {
    key: MANAGER_IMPREST_STATES.WAIT_FOR_FINALIZED,
    value: ManagerImprestStateText[MANAGER_IMPREST_STATES.WAIT_FOR_FINALIZED]
  },
  {
    key: MANAGER_IMPREST_STATES.CONFIRMED,
    value: ManagerImprestStateText[MANAGER_IMPREST_STATES.CONFIRMED]
  },
  {
    key: MANAGER_IMPREST_STATES.FINALIZED,
    value: ManagerImprestStateText[MANAGER_IMPREST_STATES.FINALIZED]
  }
];

export const IMPREST_STATES_ARRAY = [
  {
    key: MANAGER_IMPREST_STATES.WAIT_FOR_ME,
    value: ManagerImprestStateText[MANAGER_IMPREST_STATES.WAIT_FOR_ME]
  },
  {
    key: MANAGER_IMPREST_STATES.WAIT_FOR_FINALIZED,
    value: ManagerImprestStateText[MANAGER_IMPREST_STATES.WAIT_FOR_FINALIZED]
  },
  {
    key: MANAGER_IMPREST_STATES.CONFIRMED,
    value: ManagerImprestStateText[MANAGER_IMPREST_STATES.CONFIRMED]
  },
  {
    key: MANAGER_IMPREST_STATES.FINALIZED,
    value: ManagerImprestStateText[MANAGER_IMPREST_STATES.FINALIZED]
  },
  {
    key: MANAGER_IMPREST_STATES.WAIT_FOR_OTHERS,
    value: ManagerImprestStateText[MANAGER_IMPREST_STATES.WAIT_FOR_OTHERS]
  },
  {
    key: MANAGER_IMPREST_STATES.NOT_SENT,
    value: ManagerImprestStateText[MANAGER_IMPREST_STATES.NOT_SENT]
  }
];
